import React, { useState } from 'react';
// import theme from './FeatureOverview.module.scss';
import { useAsyncStateWithIsLoading } from '@/utils/hooks';
import { FeatureDefinitionDTO, getFeatureDefinitions } from '@/services/featureDefinition';
import { createDataTable } from '@/components/DataTable';
import { CustomLink, InfoIconWithTooltip, LoadingIndicator, MarkdownDisplay } from '@ygtechnologies/bygr-frontend-component-library';
import { AlertBanner } from '@ygtechnologies/rubus-ui';

export interface FeatureOverviewProps {}

const DataTable = createDataTable<FeatureDefinitionDTO>();

export const FeaturesOverview: React.FC<FeatureOverviewProps> = () => {
    const [tableState, setTableState] = useState(DataTable.getInitialState('featureName'));
    const [featureDefinitions] = useAsyncStateWithIsLoading(getFeatureDefinitions, [], null);

    if (!featureDefinitions) {
        return <LoadingIndicator />;
    }
    return (
        <>
            <h2>Features overview</h2>
            <AlertBanner type="info">
                <MarkdownDisplay
                    markdown={`
The following functions are **not part of the main Feature Overview**, but can be **enabled or disabled** in other areas of Macgyver:
 - **AI Ruben** - Toggle on/off under Licenses in both the Company Profile and Project settings.
 - **Paying Customer** - Enable or disable in the Dashboard of the Company Profile.
 - **Analytics Enabled (PBI AM)** - Enable or disable in the Dashboard of the Company Profile.
 - **Subproject** - Add a Sub-project in a Project via the Linked Project tab.
 - **Case Inbox** - Toggle on/off under Licenses in projects.
`}
                />
            </AlertBanner>
            <DataTable
                onStateChange={setTableState}
                state={tableState}
                hasPagination={false}
                className="table style-3"
                data={featureDefinitions}>
                <DataTable.Column
                    header="Feature"
                    field="featureName"
                    renderer={({ row }) => (
                        <CustomLink to={`features/${row.featureName}`}>
                            {row.featureName} <InfoIconWithTooltip content={row.information} />
                        </CustomLink>
                    )}
                />
                <DataTable.Column header="Is paid feature" field="isPaid" renderer={(x) => (x.value ? 'Yes' : 'No')} />
                <DataTable.Column header="Info" field="information" />
                <DataTable.Column
                    header="Is Experimental"
                    field="isExperimental"
                    renderer={(x) => (x.value ? 'Yes' : 'No')}
                />
                <DataTable.Column
                    header="Is Profile feature"
                    field="isProfileOnlyFeature"
                    renderer={(x) => (x.value ? 'Yes' : 'No')}
                />
            </DataTable>
        </>
    );
};
